import React from 'react';

const BasicShell = ({ children }) => React.Children.only(children);

BasicShell.renderTemplate = 'basic';

export default BasicShell;



// WEBPACK FOOTER //
// ./app/subShell/BasicShell.js